module.exports = __webpack_public_path__ + "static/media/edit.05820831.svg";